//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/SelectFace.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[1,"EdgeCollector",0,"ScCollector",0],[0,"EditCopy",1,0],[1,"Face",0,"SelectFace",0],[0,"RemoveBoundary",1,0],[1,"UEndDistance",0,"Expression",0],[1,"UEndLimit",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"UStartDistance",0,"Expression",0],[1,"UStartLimit",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"VEndDistance",0,"Expression",0],[1,"VEndLimit",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"VStartDistance",0,"Expression",0],[1,"VStartLimit",0,"GeometricUtilities.OnPathDimensionBuilder",0]],[[["object"],"SetCurrentFeature",{},1,0],[[],"UpdateBoundingBox",{},0,0],[[],"CreateProductBoundingBox",{},0,0],[[],"CleanUpFeaturesCreated",{},0,0],[[],"CreateCopyFace",{},0,0],[["originalFace"],"SetOriginalFace",{},1,0],[["limitType"],"SetLimitChangeValue",{},1,0],[["distanceValues"],"SetInitialDistanceValue",{},1,0]],[]];
SPLM.GeometricUtilities.LocalUntrimBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.LocalUntrimBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;